import { render } from "./App.vue?vue&type=template&id=366b37ae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=366b37ae&lang=css"
import "../node_modules/@vonage/vivid/styles/tokens/theme-light.css?vue&type=style&index=1&lang=css"
import "../node_modules/@vonage/vivid/styles/fonts/spezia-variable.css?vue&type=style&index=2&lang=css"

import exportComponent from "/codebuild/output/src469271911/src/vbc-call2teams-integration/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__